import React, { useContext } from 'react';
import { AppContext } from '../../contexts/app-context';
import { Image } from 'theme-ui';
import { BaseAccordion } from './base-accordion';
import accordionIconClose from 'assets/accordion-arrow.svg';
import accordionIconOpen from 'assets/accordion-arrow-e.svg';
import {
  AccordionButton,
  AccordionItem,
  AccordionContents,
  single,
  preventClose,
  combineReducers,
} from './shared';

export default function Accordion({ items, ...props }) {
  const { language } = useContext(AppContext);
  const es = language == "es";

  const openIcon = <Image src={accordionIconOpen} alt="open icon" />;
  const closeIcon = <Image src={accordionIconClose} alt="close icon" />;
  return (
    <BaseAccordion
      stateReducer={combineReducers(single, preventClose)}
      {...props}
    >
      {({ openIndexes, handleItemClick }) => (
        <>
          {items.map((item, index) => (
            <AccordionItem
              key={item.title}
              isOpen={openIndexes.includes(index)}
            >
              <AccordionButton onClick={() => handleItemClick(index)}>
              <span
                className={openIndexes.includes(index) ? 'startIcon open' : 'startIcon closed'}
              ></span>
                {es ? item.titleEs || item.title : item.title}
                <span
                  className={openIndexes.includes(index) ? 'endIcon open' : 'endIcon closed'}
                >
                  {openIndexes.includes(index) ? openIcon : closeIcon}
                </span>
              </AccordionButton>
              <AccordionContents isOpen={openIndexes.includes(index)}>
                {es ? item.contentsEs || item.contents : item.contents}
              </AccordionContents>
            </AccordionItem>
          ))}
        </>
      )}
    </BaseAccordion>
  );
}
